/*
 * Copyright (c) 2023-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import UserAvatar from "../UserComponents/UserAvatar.jsx";
import Transition from "../Transition.jsx";
import {UI} from "../../UIGenerator.jsx";
import DetectOutsideClick from "../DetectOutsideClick.jsx";
import CurrentUser from "authClient/currentUser";
import Time from "toolbox/time";
import DisplayIcon from "../Icons/DisplayIcon.jsx";

const userInfoTransitonSyles = {
    entering: "opacity-0 scale-20 -translate-y-20",
    entered: "opacity-100 scale-100 translate-y-0",
    preExit: "opacity-100 scale-100",
    exiting: "opacity-0 scale-95 -translate-y-10",
    exited: "opacity-0 scale-20 -translate-y-20",
};

class ProfileDropdown extends Component {
    constructor() {
        super();

        this.state = {
            isOpen: false,
            userAttributes: {}
        }
    }

    async logout() {
        CurrentUser.logout()
    }

    async fetchData() {
        let data = await CurrentUser.getUserInfo()
        this.setState({userAttributes: data})
    }

    componentDidMount() {
        this.fetchData()

        this.interval = Time.runInterval(() => {
            // every 5 min update to check if the user infos have changed
            this.fetchData()

        }, 300) // every 5 min


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.interval()
    }

    render() {
        let {isOpen, userAttributes} = this.state

        return (
            <>
                {/* Profile dropdown */}
                <div className=" sm:mr-1 relative ">
                    <div className={"invisible sm:visible"}>
                        <button type="button"
                                onClick={() => {
                                    // toggle the user dialog
                                    this.setState({isOpen: true})
                                }}
                                className="max-w-xs  flex items-center text-sm focus:outline-hidden  xl:p-2  xl:hover:bg-gray-50"
                                id="user-menu" aria-expanded="false" aria-haspopup="true">
                            {/* User Image */}
                            <UserAvatar firstName={userAttributes.firstName}
                                        surname={userAttributes.surname}
                                        userId={userAttributes.indexKey}
                                        size={"normal"}/>


                            {/*<span*/}
                            {/*    className="hidden ml-3 text-gray-700 text-sm font-medium xl:block xl:w-36 text-left truncate"><span*/}
                            {/*    className="sr-only">Open user menu for </span>{userAttributes.firstName} {userAttributes.surname}</span>*/}
                            {/* Heroicon name: solid/chevron-down */}
                            {/*<svg*/}
                            {/*    className="hidden shrink-0 ml-1 h-5 w-5 text-gray-400 xl:block"*/}
                            {/*    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"*/}
                            {/*    fill="currentColor" aria-hidden="true">*/}
                            {/*    <path fillRule="evenodd"*/}
                            {/*          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"*/}
                            {/*          clipRule="evenodd"/>*/}
                            {/*</svg>*/}
                        </button>
                    </div>

                    <Transition in={isOpen} timeout={{enter: 10, exit: 700}}>
                        {state => (
                            <div
                                className={"origin-top-right absolute right-0 mt-1 w-80  py-1  focus:outline-hidden z-10  transition-all ease-linear duration-200 delay-0 transform  " + userInfoTransitonSyles[state]}
                                role="menu" aria-orientation="vertical" aria-labelledby="user-menu">
                                <DetectOutsideClick isOpen={this.state.isOpen}
                                                    onOutsideClick={() => {
                                                        this.setState({isOpen: false})
                                                    }}>
                                    <div
                                        className="col-span-1 bg-white rounded-lg shadow-lg divide-y divide-stone-200 ring-1 ring-stone-200 overflow-hidden">
                                        <div
                                            className="w-full flex items-center justify-between p-6 space-x-6 hover:bg-stone-50 cursor-pointer"
                                            onClick={() => {
                                                UI.page().navigate({
                                                    pathname: `/settings`,
                                                })
                                                this.setState({isOpen: false})

                                            }}
                                            onMouseDown={(event) => {
                                                // on middle mouse click
                                                if (event.button === 1) {
                                                    // open website in new window
                                                    UI.page().navigateNewTab({
                                                        pathname: "/settings",
                                                    })
                                                }
                                            }}
                                        >
                                            <UserAvatar firstName={userAttributes.firstName}
                                                        surname={userAttributes.surname}
                                                        userId={userAttributes.indexKey}
                                                        size={"large"} displayStatus={true}
                                                        status={"online"}/>


                                            <div className="flex-1 truncate">
                                                <div className="flex items-center space-x-2">
                                                    <h3 className="text-gray-900 text-sm font-medium truncate">{userAttributes.firstName} {userAttributes.surname}</h3>
                                                    <span
                                                        className="shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full">{userAttributes.role}</span>


                                                </div>
                                                {/*<p className="mt-1 text-gray-500 text-sm truncate">Product*/}
                                                {/*    Directives Officer</p>*/}


                                            </div>

                                        </div>
                                        <div>
                                            <div className="-mt-px flex divide-x divide-stone-200">
                                                {/*<AdminSection>*/}
                                                {/*    <div*/}
                                                {/*        className="w-0 flex-1 flex  hover:bg-gray-50 rounded-bl-md">*/}
                                                {/*        <div onClick={() => {*/}

                                                {/*            UI.page().navigate({*/}
                                                {/*                pathname: `/tenantsettings`,*/}
                                                {/*            })*/}
                                                {/*            this.setState({isOpen: false})*/}

                                                {/*        }}*/}

                                                {/*             onMouseDown={(event) => {*/}
                                                {/*                 // on middle mouse click*/}
                                                {/*                 if (event.button === 1) {*/}
                                                {/*                     // open website in new window*/}
                                                {/*                     UI.page().navigateNewTab({*/}
                                                {/*                         pathname: "/tenantsettings",*/}
                                                {/*                     })*/}
                                                {/*                 }*/}
                                                {/*             }}*/}


                                                {/*             className="relative no-underline -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 cursor-pointer ">*/}

                                                {/*            <DisplayIcon iconName={"IoSettingsOutline"}*/}
                                                {/*                         className="w-5 h-5 text-gray-400"/>*/}

                                                {/*            <span*/}
                                                {/*                className="ml-3 select-none">Settings</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}
                                                {/*</AdminSection>*/}
                                                <div
                                                    className="-ml-px w-0 flex-1 flex  hover:bg-gray-50 rounded-br-md">
                                                    <div onClick={async () => {

                                                        // logout
                                                        this.logout()
                                                        this.setState({isOpen: false})

                                                    }}
                                                         className="relative no-underline  w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500 cursor-pointer">

                                                        <DisplayIcon iconName={"IoExitOutline"}
                                                                     className="w-5 h-5 text-gray-400"/>
                                                        <span className="ml-3 select-none">Logout</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </DetectOutsideClick>
                            </div>
                        )}
                    </Transition>
                </div>
            </>
        );
    }
}

ProfileDropdown.propTypes = {};

export default ProfileDropdown;